export default __webpack_public_path__ + "static/media/KsBulletWhite.08ea947f.svg";